import { render, staticRenderFns } from "./FilterMonetizationTypes.vue?vue&type=template&id=16973a0a"
import script from "./FilterMonetizationTypes.vue?vue&type=script&lang=ts"
export * from "./FilterMonetizationTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports